// 引入数据配置文件
import FormConfig from "../formConfig.js";
import { fun_PostAction, fun_GetAction } from "@/api/index";
import Pictureinfor from "../../../components/pictureinfor/index.vue";
import ElectronicLicense from "../../components/electronicLicense/index.vue";
import AuditHistoryRecord from "../../../components/auditHistoryRecord/index.vue";

export default {
  data() {
    return {
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 表单对象
      form: {
        // 主键
        id: null,
        // 企业名称
        corpName: null,
        // 社会信用代码
        corpCode: null,
        // 资质资格类型
        certTypeNum: null,
        // 证书编号
        certId: null,
        // 资质资格最高等级
        modifyTypeId: null,
        // 发证机关
        organName: null,
        // 发证日期
        organDate: null,
        // 证书有效期截止日期
        endDate: null,
        // 证书状态
        isValid: null,
        // 承接业务
        undertaking: null,
        // 备注
        description: null,
        // 状态
        stateName: null
      },
      // 表头按钮
      btnList: [
        {
          name: "添加",
          type: "success",
          icon: "circle-plus-outline"
        },
        {
          name: "修改",
          type: "primary",
          icon: "edit-outline"
        },
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        }
      ],
      // 企业资质资格信息绑定数据
      formObj: {
        // 表格数据
        tableData: []
      },
      // 企业资质资格信息点击下标
      formObjIndex: null,
      // 勾选的数据
      multipleSelection: [],
      // 企业资质资格信息列表加载
      loading: false,
      // 企业资质资格信息绑定验证规则
      rules: {
        tradeTypeNum: [
          {
            required: true,
            message: "请选择资质资格序列",
            trigger: "change"
          }
        ],
        tradeBoundNum: [
          {
            required: true,
            message: "请选择专业类别",
            trigger: "change"
          }
        ],
        titleLevelNum: [
          {
            required: true,
            message: "请选择资质资格等级",
            trigger: "change"
          }
        ],
        mark: [
          {
            required: true,
            message: "请输入批准资质资格内容",
            trigger: "change"
          }
        ],
        noteDate: [
          {
            required: true,
            message: "请选择首次批准资质资格日期",
            trigger: "change"
          }
        ],
        addTypeNum: [
          {
            required: true,
            message: "请选择资质资格取得方式",
            trigger: "change"
          }
        ],
        certTradeStatusNum: [
          {
            required: true,
            message: "请选择资质资格状态",
            trigger: "change"
          }
        ]
      },
      // 核验记录条数
      auditNum: 0,
      // 交易人资质数量
      corpCertNum: 0,
      // 注册人人数
      regPersonNum: 0,
      // 交易人业绩数量
      corpAchievementNum: 0,
      // 企业奖励数量
      corpRewardsNum: 0,
      // 企业惩罚数量
      corpPunishmentNum: 0,
      // 银行基本户数量
      basicDepositAccountNum: 0,
      // 电子证照是否开启
      electronicLicenseFlag: null,
      // 是否跳转完善企业类型
      corpFlag: null,
      certTypeNumOptions: [],
      isValidOptions: [],
      // 资质资格序列下拉框数据
      tradeTypeNumOptions: [],
      // 专业类别下拉框数据
      tradeBoundNumOptions: [],
      // 资质资格等级下拉框数据
      titleLevelNumOptions: [],
      // 资质资格取得方式下拉框数据
      optionsAddTypeOptions: [],
      // 资质资格状态下拉框数据
      optionsCertTradeStatusOptions: [],
      // 登录角色标识
      userFlag: sessionStorage.getItem("userFlag"),
      // 全局加载
      fullLoading: null,
    };
  },

  // 注册组件
  components: {
    ElectronicLicense, // 电子证照一览
    Pictureinfor, // 附件上传
    AuditHistoryRecord // 历史核验记录
  },

  // 接收父组件传递的数据
  props: {
    // 页面类型
    params: {
      type: Object,
      default: {}
    }
  },

  // 模板编译完成
  mounted() {
    // 判断是否为工作人员
    if(this.userFlag === "工作人员"){
      // 获取数据
      this.params = this.$route.query;
    }
    // 获取详情
    this.fun_GetDetail();
    // 获取资质资格类型下拉框数据
    this.fun_GetCertTypeNumSelect();
    // 获取证书状态下拉框数据
    this.fun_GetIsValidSelect();
    // 获取资质资格取得方式下拉框数据
    this.fun_GetAddTypeNumSelect();
    // 获取资质资格状态下拉框数据
    this.fun_GetCertTradeStatusNumSelect();
    // 页面类型为查看详情
    if (this.params.type === "details") {
      // 遍历标签页
      this.formConfigList.map(e => {
        // 遍历标签页内表单
        e.formConfigList.map(form => {
          // 置灰
          form.disabled = true;
        });
      });
      // 隐藏企业资质资格信息列表按钮
      this.btnList = [];
      // 不是查看详情
    } else {
      // 遍历标签页
      for (let i = 0; i < this.formConfigList.length; i++) {
        // 如果是其他相关信息
        if (this.formConfigList[i].title === "其他相关信息") {
          // 则删除
          this.formConfigList.splice(i, 1);
        }
      }
    }
  },
  // 自定义方法
  methods: {
    /**
     * 获取详情
     */
    fun_GetDetail() {
      // 发起请求
      fun_GetAction("/corpCertinfo/detail", {
        id: this.params.id
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 回显
          this.form = data.corpCertinfo;
          // 获取企业资质资格信息列表一览
          this.fun_GetCorpCertdetailinfoList();
          // 页面类型为查看详情
          if (this.params.type === "details" || this.params.type === "update") {
            // 获取资质资格序列下拉框数据
            this.fun_GetTradeTypeNumSelect();
            // 获取资质资格等级下拉框数据
            this.fun_GetTitleLevelNumSelect();
          }
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取企业资质资格信息列表一览
     * @author shuhua
     */
    fun_GetCorpCertdetailinfoList() {
      // 主键不为空
      if (this.params.id != null && this.params.id != "") {
        // 打开遮罩
        this.loading = true;
        // 发起请求
        fun_PostAction("/corpCertinfo/getCorpCertdetailinfoList", {
          certinfoId: this.params.id
        }).then(res => {
          // 解构res.data
          const { result, data, msg } = res.data;
          // 操作成功
          if (result) {
            // 赋值
            this.formObj.tableData = data.records;
            // 遍历
            this.formObj.tableData.map(e => {
              // 获取专业类别下拉框数据
              this.fun_GetTradeBoundNumSelect(e.tradeTypeNum);
            });
            // 关闭遮罩
            this.loading = false;
          } else {
            // 关闭遮罩
            this.loading = false;
            // 操作失败提示信息
            this.$message.error(msg);
          }
        });
      }
    },
    /**
     * 列表添加class
     */
    addClass(row, column, rowIndex, columnIndex) {
      // 判断是序号
      if (row.column.type === "index") {
        return "index"
      }
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      switch (e) {
        case "添加":
          // 调用添加方法
          var newValue = {
            tradeTypeNum: null,
            tradeBoundNum: null,
            titleLevelNum: null,
            isMaster: null,
            mark: null,
            noteNumber: null,
            noteDate: null,
            addTypeNum: null,
            certTradeStatusNum: null,
            certTradeModifyDate: null,
            certTradeModifyMark: null
          };
          //添加新的行数
          this.formObj.tableData.push(newValue);
          break;
        default:
          // 判断是否勾选
          if (this.multipleSelection.length <= 0) {
            // 提示信息
            this.$alert("最少选择一条数据！", "warning");
            return;
          }
          // 弹出询问confirm
          this.$confirm("是否确定删除选中数据?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            // 遍历
            this.multipleSelection.map((value, index) => {
              // 遍历
              this.formObj.tableData.map((v, i) => {
                // 匹配已选中的
                if (value.index === v.index) {
                  // 删除勾选的数据
                  this.formObj.tableData.splice(i, 1);
                }
              });
            });
            // 清除选中数据
            this.$refs.multipleTable.clearSelection();
          });
      }
    },
    /**
     * 获取资质资格类型下拉框数据
     * @author shuhua
     */
    fun_GetCertTypeNumSelect() {
      // 发起请求
      fun_PostAction("/dataDictionaryEntries/BasicDataCombobox", {
        zdid: "201507131554050002"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 资质资格类型下拉框数据
          this.certTypeNumOptions = data;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取证书状态下拉框数据
     * @author shuhua
     */
    fun_GetIsValidSelect() {
      // 发起请求
      fun_PostAction("/dataDictionaryEntries/BasicDataCombobox", {
        zdid: "201507131619050031"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 证书状态下拉框数据
          this.isValidOptions = data;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取资质资格序列下拉框数据
     * @author shuhua
     */
    fun_GetTradeTypeNumSelect() {
      // 清空绑定值
      this.formObj.tableData.map(e => {
        e.tradeTypeNum = null;
        e.tradeBoundNum = null;
        e.titleLevelNum = null;
      });
      // 发起请求
      fun_PostAction("/dataDictionaryEntries/Combobox", {
        table: "TB_CORP_QUALIFICATION_LIST_",
        value: "LIST_CODE_",
        name: "LIST_NAME_",
        where: "AND CERT_TYPE_NUM_ = '" + this.form.certTypeNum + "'",
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 存在数据
          if (data.length > 0) {
            // 资质资格序列下拉框数据
            this.tradeTypeNumOptions = data;
          } else {
            this.tradeTypeNumOptions = [
              {
                name: "无",
                value: "0"
              }
            ];
          }
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },

    /**
     * 获取专业类别下拉框数据
     * @author shuhua
     */
    fun_GetTradeBoundNumSelect(tradeLargeClass) {
      // 发起请求
      fun_PostAction("/corpCertinfo/getCorpQualificationListId", {
        listCode: tradeLargeClass
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 发起请求
          fun_PostAction("/dataDictionaryEntries/Combobox", {
            table: "TB_CORP_TRADETYPE_BOUND_",
            value: "TRADE_CATEGORY_CODE_",
            name: "TRADE_CATEGORY_NAME_",
            where: "AND TRADE_LARGE_CLASS_ = '" + data + "'",
          }).then(res => {
            // 解构res.data
            const { result, data, msg } = res.data;
            // 操作成功
            if (result) {
              // 专业类别下拉框数据
              this.tradeBoundNumOptions = data;
              this.tradeBoundNumOptions.unshift({ name: "无", value: "0" });
            } else {
              // 错误消息提示
              this.$message.error(msg);
            }
          });
        }
      });
    },
    /**
     * 获取资质资格等级下拉框数据
     * @author shuhua
     */
    fun_GetTitleLevelNumSelect() {
      // 发起请求
      fun_PostAction("/dataDictionaryEntries/Combobox", {
        table: "TB_CORP_QUALIFICATION_LEVEL_",
        value: "LEVEL_NUM_",
        name: "LEVEL_",
        where: "AND TYP_NUM_ = '" + this.form.certTypeNum + "'",
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 资质资格等级下拉框数据
          this.titleLevelNumOptions = data;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 获取资质资格取得方式下拉框数据
     * @author shuhua
     */
    fun_GetAddTypeNumSelect() {
      // 发起请求
      fun_PostAction("/dataDictionaryEntries/BasicDataCombobox", {
        zdid: "201507131621250036"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 回显数据
          this.optionsAddTypeOptions = data;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 资质资格状态下拉框数据
     * @author shuhua
     */
    fun_GetCertTradeStatusNumSelect() {
      // 发起请求
      fun_PostAction("/dataDictionaryEntries/BasicDataCombobox", {
        zdid: "201507131624130043"
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 回显数据
          this.optionsCertTradeStatusOptions = data;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
      });
    },
    /**
     * 资质资格类型下拉框值改变事件
     * @author shuhua
     */
    fun_ChangeCertTypeNum() {
      // 清空资质资格最高等级
      this.form.titleLevelNum = null;
      // 加载资质资格最高等级
      this.fun_GetTitleLevelNumSelect();
      // 加载资质资格序列
      this.fun_GetTradeTypeNumSelect();
    },
    /**
     * 资质资格序列下拉框值改变事件
     * @author shuhua
     */
    fun_ChangeTradeTypeNum(e) {
      // 获取专业类别下拉框数据
      this.fun_GetTradeBoundNumSelect(e);
    },
    /**
     * 企业资质资格信息列表勾选事件
     * @author shuhua
     */
    fun_HandleSelectionChange(e) {
      // 赋值勾选数组
      this.multipleSelection = e;
    },
    /**
     * 打开电子证照一览
     */
    fun_OpenElctronicLicense() {
      // 询问框
      this.$confirm("是否获取企业相关证照？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 组织机构代码为空
        if (!this.form.corpCode) {
          // 错误消息提示
          this.$alert("请填写社会信用代码！", "提示", { type: "warning" });
          return false;
        }
        // 企业名称为空
        if (!this.form.corpName) {
          // 错误消息提示
          this.$alert("请填写企业名称！", "提示", { type: "warning" });
          return false;
        }
        // 打开弹窗
        this.$refs.electronicLicense.dialogVisible = true;
        // 打开弹框时调用
        this.$refs.electronicLicense.fun_GetList();
      });
    },
    /**
     * 打开上传附件弹窗
     * @author shuhua
     */
    fun_OpenUpload() {
      // 打开弹窗
      this.$refs.pictureinfor.dialogVisible = true;
      // 打开弹框时调用
      this.$refs.pictureinfor.fun_GetOpen();
    },
    /**
     * 打开历史核验记录弹窗
     */
    fun_OpenAuditHistoryRecord() {
      // 打开弹窗
      this.$refs.auditHistoryRecord.dialogVisible = true;
      // 请求接口
      this.$refs.auditHistoryRecord.fun_GetList();
    },
    /**
     * @description 保存
     * @author
     */
    fun_Submit(e) {
      let isFormValid = false;
      let isTableValid = false;
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        if (valid) {
          isFormValid = true;
        } else {
          return false;
        }
      });
      // 表格验证
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          isTableValid = true;
        } else {
          return false;
        }
      });
      if (isFormValid && isTableValid) {
        if (e == "tj") {
          this.$confirm("确定提交？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(() => {
              // 通过
              this.form.state = "tg";
              // 提交
              this.fun_SaveOrUpdate();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消"
              });
            });
        } else {
          // 保存
          this.form.state = "bc";
          // 提交
          this.fun_SaveOrUpdate();
        }
      }
    },
    /**
     * 提交的方法
     * @author shuhua
     */
    fun_SaveOrUpdate() {
      // 打开遮罩
      this.fun_Loading();
      // 发起请求
      fun_PostAction("/corpCertinfo/saveOrUpdate", {
        ...this.form,
        id: this.params.id,
        controllerFlg: this.params.type,
        list: JSON.stringify(this.formObj.tableData),
      }).then(res => {
        // 加载框取消
        this.fullLoading.close();
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 保存时
          if (this.form.state === 'bc') {
            // 弹出提示
            this.$alert("企业资质信息保存成功！请上传相关证照的扫描件！", "warning").then(() => {
              // 修改操作类型
              this.params.type = 'update';
              // 主键
              this.params.id = data;
              // 重新加载详情
              this.fun_GetDetail();
            })
            .catch(() => {
              // 修改操作类型
              this.params.type = 'update';
              // 主键
              this.params.id = data;
              // 重新加载详情
              this.fun_GetDetail();
            });    
          } else {
            // 操作成功
            this.$message.success(msg);
            // 返回
            this.$emit("fun_Back");
          }
        } else {
          // 返回错误消息不为空
          if (msg != "操作失败！") {
            // 提示
            this.$alert(msg, "warning");
          } else {
            // 操作失败
            this.$message.error(msg);
          }
        }
      })
      .catch(() => {
        // 加载框取消
        this.fullLoading.close();
      });
    },
    /**
     * 全局加载
     * @author liutong
     */
    fun_Loading(val) {
      this.fullLoading = this.$loading({
        lock: true,
        text: val ? val : "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.8)"
      });
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 判断是工作人员
      if(this.userFlag === '工作人员'){
        // 返回
        this.$router.back();
      }
      // 返回
      this.$emit("fun_Back");
    }
  }
};
